import React from 'react'
import { WorkflowTemplateManagement } from './WorkflowTemplateManagement'

const WorkFlowTemplate = () => {
    return (
        <>
            <WorkflowTemplateManagement />
        </>
    )
}

export default WorkFlowTemplate
